import React, {useState} from 'react';
import {EdgeProps, getBezierPath} from 'reactflow';
import {useSmartTriggerConfiguration} from "../../context/smartTriggerConfigurationProvider";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './buttonEdge.css'
import {
    SmartTriggerProcessorSpotlight,
    SmartTriggerProcessorSpotLightPayload
} from "../spotlights/smartTriggerProcessorSpotlight";
import {openSpotlight} from "@mantine/spotlight";
import {
    SmartTriggerProcessorConfigurationAction,
    SmartTriggerProcessorConfigurationModal
} from "../processorConfiguration/smartTriggerProcessorConfigurationModal";


const foreignObjectSize = 40;

export default function ButtonEdge({
                                       id,
                                       sourceX,
                                       sourceY,
                                       targetX,
                                       targetY,
                                       sourcePosition,
                                       targetPosition,
                                       style = {},
                                       markerEnd,
                                   }: EdgeProps) {

    const smartTriggerConfiguration = useSmartTriggerConfiguration();
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const splitId = id.split(":")

    const previous = splitId[0]
    const next = splitId[1]
    const [newConfigurationModalOpened, setNewConfigurationModalOpened] = useState(false);

    const [smartTriggerProcessorConfigurationAction, setSmartTriggerProcessorConfigurationAction] = useState<SmartTriggerProcessorConfigurationAction>({
        type: "new",
        previous: previous,
        next: next
    });

    // const size = useStore(s => {
    //     const node = s.nodeInternals.get(previous as string);
    //     if (!node) {
    //         return {
    //             width: 0,
    //             height: 0
    //         }
    //     }
    //     return {
    //         width: node.width,
    //         height: node.height,
    //     };
    // });
    //
    // const onEdgeClick = (evt: React.MouseEvent<HTMLButtonElement>, id: string) => {
    //     evt.stopPropagation();
    //     // const previous = id.split(":")[0]
    //     // const nextNode = id.split(":")[1]
    //     // smartTriggerConfiguration.addNewProcessor({
    //     //     id: previous,
    //     //     height: size.height as number,
    //     //     width: size.width as number
    //     // }, nextNode, 'script');
    // };

    function onTrigger(actionPayload: SmartTriggerProcessorSpotLightPayload) {
        if (actionPayload.action === 'new') {
            setSmartTriggerProcessorConfigurationAction({
                type: "new",
                previous: previous,
                next: next
            })
        }
        if (actionPayload.action === "pull") {
            setSmartTriggerProcessorConfigurationAction({
                type: "pull",
                processorRepositoryId: actionPayload.payload.processorRepositoryId as string,
                previous: previous,
                next: next
            })
        }
        setNewConfigurationModalOpened(false);
    }

    return (
        <>
            <path
                id={id}
                style={style}
                className="react-flow__edge-path"
                d={edgePath}
                markerEnd={markerEnd}
            />
            <foreignObject
                width={foreignObjectSize}
                height={foreignObjectSize}
                x={labelX - foreignObjectSize / 2}
                y={labelY - foreignObjectSize / 2}
                className="edgebutton-foreignobject"
                requiredExtensions="http://www.w3.org/1999/xhtml"
            >
                <div>
                    <SmartTriggerProcessorSpotlight previousProcessorId={previous}
                                                    nextProcessorId={next}
                                                    onTrigger={onTrigger}
                                                    type={'PROCESSOR'}>
                        <button className="edgebutton" onClick={(event) => openSpotlight()}>
                            <FontAwesomeIcon color={"green"} icon={faPlus}/>
                        </button>
                    </SmartTriggerProcessorSpotlight>
                    {
                        newConfigurationModalOpened &&
                        <SmartTriggerProcessorConfigurationModal action={smartTriggerProcessorConfigurationAction}
                                                                 isOpened={newConfigurationModalOpened}
                                                                 onClose={() => setNewConfigurationModalOpened(false)}/>
                    }
                </div>
            </foreignObject>
        </>
    );
}
